<div class="flex-fill d-flex flex-column card p-3">
    <div style="max-width: 1050px">
        <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
            <dxi-item itemType="group">
                <dxi-item
                    dataField="customerId"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Customer' }"
                    [editorOptions]="{ dataSource: customersDS, displayExpr: 'name', valueExpr: 'id', showClearButton: true }"
                ></dxi-item>
                <dxi-item
                    dataField="statusId"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: statuses, displayExpr: 'name', valueExpr: 'id', showClearButton: true }"
                    [label]="{ text: 'Status' }"
                ></dxi-item>
                <dxi-item
                    dataField="ticketTypeId"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: ticketTypes, displayExpr: 'name', valueExpr: 'value', showClearButton: true }"
                    [label]="{ text: 'Ticket Type' }"
                ></dxi-item>
                <dxi-item dataField="invoiceNumber" editorType="dxNumberBox" [label]="{ text: 'Invoice #' }"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                <dxi-item dataField="invoiceDateStart" editorType="dxDateBox"></dxi-item>
                <dxi-item dataField="invoiceDateEnd" editorType="dxDateBox"></dxi-item>
            </dxi-item>
        </dx-form>
        <div class="btn-toolbar justify-content-end align-items-center mt-1">
            <div *ngIf="invoices" class="me-3">{{ invoices.length }} {{ invoices.length === 1 ? "item found" : "items found" }}</div>
            <button accesskey="s" (click)="search()" class="btn btn-primary me-3">Search</button>
            <button (click)="clear()" class="btn btn-secondary me-3">Clear</button>
        </div>
    </div>
    <div class="d-flex flex-fill flex-column">
        <dx-data-grid #dataGrid keyExpr="id" class="flex-fill d-flex flex-column" [dataSource]="invoices" (onRowDblClick)="rowDoubleClick($event)">
            <dxi-column dataField="invoiceNumber" caption="Invoice #" width="80"></dxi-column>
            <dxi-column dataField="companyName" caption="Customer" width="200"></dxi-column>
            <dxi-column dataField="shipTo" width="200"></dxi-column>
            <dxi-column dataField="invoiceDate" caption="Date" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
            <dxi-column dataField="subTotal" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="tax" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="balance" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="ticketType" width="150"></dxi-column>
            <dxi-column dataField="preferredCommunication" caption="Comm." width="100"></dxi-column>
            <dxi-column dataField="isMail" width="100"></dxi-column>
            <dxi-column dataField="isEmail" width="100"></dxi-column>
            <dxi-column dataField="email" caption="Email" width="200"></dxi-column>
            <dxi-column dataField="emailed" caption="Sent" dataType="date" width="200" [format]="{ type: 'shortDateShortTime' }"></dxi-column>
            <dxi-column dataField="paid" dataType="date" width="200" [format]="{ type: 'shortDateShortTime' }"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-sorting [mode]="'multiple'"></dxo-sorting>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="invoice-history-grid"></dxo-state-storing>
            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-sm btn-primary me-2"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="invoices" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + " items" }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
